import { Paths } from "@/app/paths";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = () => {
  // TODO: Use authentication token
  const localStorageToken = localStorage.getItem("token");

  return localStorageToken ? (
    <Outlet />
  ) : (
    <Navigate to={Paths.SignIn} replace />
  );
};

export default ProtectedRoute;
